import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Radio, Space, message } from 'antd';
import { isMobile } from 'react-device-detect';
import { setPrimaryPhone } from '@/redux/actions/customerActions';

const { confirm } = Modal;

class PhoneList extends Component {
    constructor() {
        super();
        this.state = {
            selectedPhoneId: null,
        };
    }

    onClose() {
        this.props.onCancel();
    }

    handleChange = (e) => {
        const phone_id = e.target.value;
        const selectedPhone = this.props.data.find(p => p.id === phone_id);

        confirm({
            title: 'Bạn có chắc muốn đặt số này là số chính?',
            content: selectedPhone.phone,
            okText: 'Đồng ý',
            cancelText: 'Hủy',
            onOk: () => {
                this.props.setPrimaryPhone({ phone_id: phone_id });
                this.props.reloadCustomer();
                this.setState({ selectedPhoneId: phone_id });
                //message.success('Đã cập nhật số chính!');
            }
        });
    }

    render() {
        const { visible, data } = this.props;
        const { selectedPhoneId } = this.state;

        return (
            <Modal
                visible={visible}
                title="Danh sách số điện thoại"
                onCancel={() => this.onClose()}
                footer={null}
                maskClosable={false}
                width={isMobile ? '100%' : '30%'}
            >
                {visible && data && data.length > 0 ? (
                    <Radio.Group
                        onChange={this.handleChange}
                        value={selectedPhoneId ?? data.find(p => p.is_primary === 1)?.id}
                        style={{ width: '100%' }}
                    >
                        <Space direction="horizontal" style={{ width: '100%' }}>
                            {data.map((item) => (
                                <Radio key={item.id} value={item.id}>
                                    {item.phone}
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>
                ) : (
                    <p>Không có số điện thoại nào.</p>
                )}
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        setPrimaryPhone: (data) => dispatch(setPrimaryPhone(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneList);
